<div class="glass-house-description">
  <span>{{ data | method: 'getProductGroupingDescription' | trimSafely }}</span>
</div>
